import type { MouseEvent, FC, ReactNode } from "react";
import { motion } from "motion/react";
import { type IndicatorProps, Tooltip } from "@huub-web/ui";
import { mergeClasses } from "@huub-web/utils";
import { markerShadowStyle, markerStyle } from "./Marker.css";

export type MarkerProps = {
  type?: "marker" | "dot" | "cluster";
  title?: string;
  subtitle?: ReactNode;
  indicatorVariant?: IndicatorProps["variant"];
  delay?: number;
  animate?: boolean;
  left?: number;
  top?: number;
  tooltip?: ReactNode;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
};

export const Marker: FC<MarkerProps> = ({
  left,
  top,
  animate = true,
  // title,
  // subtitle,
  // indicatorVariant,
  delay,
  tooltip,
  onClick,
}) => (
  <Tooltip value={tooltip}>
    <motion.div
      aria-hidden="true"
      className={mergeClasses(markerStyle({ hoverable: !!onClick }))}
      style={{
        left: left ? `${left}%` : undefined,
        top: top ? `${top}%` : undefined,
      }}
      initial={animate ? { opacity: 0, scale: 0.8 } : { opacity: 1, scale: 1 }}
      animate={animate ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
      transition={{
        duration: 0.2,
        ease: [0.25, 0.1, 0.25, 1],
        delay,
      }}
      onClick={onClick}
    >
      <div className={mergeClasses(markerShadowStyle)}></div>
    </motion.div>
  </Tooltip>
);
